import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { ComparacaoArquivosComponent } from './comparacao-arquivos.component';
import { ImportacaoModule } from '../../components/importacao/importacao.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
    ImportacaoModule
  ],
  declarations: [ComparacaoArquivosComponent]
})
export class ComparacaoArquivosModule { }